export const LIST_OWN = 'ownedReferenceTypesList';
export const LIST_OWN_AND_DOWN = 'allReferenceTypesList';
export const LIST_AVAILABLE = 'allAvailableReferenceTypesList';
export const ADD_REFERENCE_TYPE_FORM = 'ADD_REFERENCE_TYPE_FORM';
export const EDIT_REFERENCE_TYPE_FORM = 'EDIT_REFERENCE_TYPE_FORM';
